import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/sections/Hero';
import { About } from './components/sections/About';
import { Services } from './components/sections/Services';
import { Sermons } from './components/sections/Sermons';
import { Testimonies } from './components/sections/Testimonies';
import { Events } from './components/sections/Events';
import { Ministries } from './components/sections/Ministries';
import { Giving } from './components/sections/Giving';
import { EmailRegistration } from './components/sections/EmailRegistration';
import { Contact } from './components/sections/Contact';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="w-full h-full overflow-auto scroll-smooth font-body bg-stone-50 text-slate-800">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Sermons />
        <Testimonies />
        <Events />
        <Ministries />
        <Giving />
        <EmailRegistration />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
